import type { OptinOrigin } from '@ms/yammer-telemetry';
import { reportUsage } from '@ms/yammer-telemetry';

import type { User } from '../../state/types';
import type { PromiseThunkAction } from '../../types';

import { updateUserPreferences } from './updateUserPreferencesActions';

type UpdateOptInPreference = (optinOrigin: OptinOrigin, userId: User['id']) => PromiseThunkAction<void>;
export const updateOptInPreference: UpdateOptInPreference = (optinOrigin, userId) => async (dispatch) => {
  reportUsage({
    eventName: 'user_optedin',
    eventProperties: {
      origin: optinOrigin,
    },
  });

  const action = updateUserPreferences({ isModernClientPreferred: true }, userId);
  try {
    await dispatch(action);
  } catch {
    // retry the action once more
    await dispatch(action);
  }
};
